<template>
  <div>
    <div class="container">
      <Breadcrumbs />
      <div class="row">
        <div class="col-12 dBtn">
          <q-btn disable data-cy="bNewCity" unelevated class="bPrincipal">
            CREAR NUEVO INDICADOR
          </q-btn>
        </div>
      </div>
      <div class="row"></div>
      <div class="row col-12">
        <div class="col-12">
          <AdminListado />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import AdminListado from '../components/AdminListado.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  mixins: [Message],
  components: { AdminListado, Breadcrumbs },
  data () {
    return {
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.bPrincipal {
  float: right;
}
.dBtn {
  margin-bottom: 15px;
}
</style>
